import { z } from 'zod';
import { TimespanUnit } from '../index.js';
import { SystemProcedure } from './system.js';
export { SystemProcedure };
export const SystemProcedureId = {
    CreditorEndedCase: 'c8f46b94-3a17-4345-ae72-8d2fcb2ed2f9',
    Overpayment: '2bf2187e-259e-4176-a762-859e4688ba3b',
    EndCase: '77b8678a-a6dd-4005-b320-7a9cc963f751',
    EndCaseAccord: 'daeb7db3-8f2e-48bd-b075-cdcf0faa6435',
    PrincipalPayment: '61ddc972-b02d-44e0-b9bc-3c746e1c1be4',
    RemainderReminder: '61ddc972-b02d-44e0-b9bc-3c746e1c1be4',
    PaymentOnCourtCase: '47d383b7-f239-4566-abb2-58cae4d9bd30',
    Update: 'e205691e-4197-4152-81a6-09de315cb70a',
    PaymentPlanInitial: '0094d8b6-e037-43ed-a559-6c813f1ae4e8',
    PaymentPlanReminder: 'fd8def41-235c-45fc-a4e4-37e435672034',
    PaymentPlanPayment: 'ae304800-fc5c-4e27-9982-8165ce338735',
    PaymentPlanAutoPaymentFailure: 'e79ed266-6cc8-46d6-9547-98207e34c9fe',
    PaymentPlanBSLSSubmitFailed: '767024fe-a406-4c8a-92fd-bbb39bd9a97f',
    PaymentPlanBSLSRejected: '2afe722c-f8dd-4852-b73d-47f7fbdfb929',
    PaymentPlanBSLSAgreementCancelled: '98371161-f815-469f-936a-b8cfcc2c0f7e',
    PaymentPlanDeadline: '23df7219-0e65-4988-8214-96c7c51b0fd4',
    PaymentPlanCanceled: '48bb8a74-f4d3-429f-9e92-6a7af3b9bae0',
    PaymentPlanTwoHourActivationReminder: '7bfad0f0-a988-4158-916e-05c04a5355b9',
    PaymentPlanOneDayActivationReminder: '04431f4c-6edd-4b71-a74e-3185bf85e1d0',
    PaymentPlanThreeDayActivationReminder: '3e121ddc-178c-4ed8-9d06-4932d675d3da',
    PaymentPlanCreationByCaseworker: '9a845e01-0cb7-4a5c-aff6-8049bbf2be80',
    DebtExpired: 'dca63891-d881-4b78-9f28-ec7695dadc16',
    DebtExpiresWithinThreeMonths: '0dd28b1a-1bcf-4e51-90f9-7bfcd8ea3078',
    DebtExpiresWithinThreeMonthsWithFoundation: '12dcdfd5-b950-40e3-82d9-edc7ffddf1dc',
    DebtorCanBeRegisteredInDebtRegister: 'd402cb4e-8632-4238-aad7-bc480641bd99',
    DebtorIsUnderage: '3fbba86c-fc97-4584-95c1-f3b20f9f883e',
    Address: 'b9c1d0f7-ad7f-42ec-8f92-25053160b7f0',
    Active: '577b3e2b-d0ae-448f-9247-f4c60e23f67a',
    Dead: 'da88e103-c41a-4a9e-9b85-9e2a8154b638',
    Disappeared: '0e703bd6-347b-41bb-a7d7-5d49b3ddc30a',
    MovedAbroad: 'd255fc58-6e33-4314-90b0-7badccde265c',
    Homeless: 'ab502d87-9aa0-4a92-8b62-1265eea7b183',
    CompanyActive: '002e7adf-602b-45af-abdd-cd0385068be0',
    Inactive: 'ba2e6b27-7362-4a20-8b8f-a95009aff594',
    OperationsCeased: '1c1c7c9a-645d-4774-aa36-799046a4e3e6',
    AddressProtection: 'a32bc204-a5a3-4682-97db-1fe9ef474878',
    NewRKIRegristration: '771c9e5b-dd24-45be-a715-276f9549d381',
    DeletedRKIRegistration: '8ab48245-f8fa-4c2c-a0f5-2ce3549b37fe',
    DeletedRKIRegistrationWillingnessToPay: 'd1d9540c-65de-431a-a565-b0479b4be465',
    GuardianStatus: 'a3589d46-f414-4219-812d-9ffeef3fe612',
    DissolutionStatus: 'e9a22007-4ddd-4e06-8208-4a95c60d683e',
    BOBEHANDLING: '92a4abaf-89d1-4a08-90dc-07e2d9ca62d8',
    AKSFailed: 'cd34cce6-e11a-4b6f-a4f0-12a6c496d14a',
    AgentEscalatedToHuman: 'b1a7e8d4-2c5f-4a3e-8b6c-9e2f1a7d5b4c',
    EmailJournalized: '7fbefe54-d2ff-4718-a81a-6f8e083c54e7',
    CourtEmailJournalized: 'e4dfd35f-1a29-4ef3-a2ca-ec4131c273a4',
};
export var TriggerFoundationFilter;
(function (TriggerFoundationFilter) {
    TriggerFoundationFilter["Any"] = "ANY";
    TriggerFoundationFilter["WithFoundation"] = "WITH_FOUNDATION";
    TriggerFoundationFilter["WithoutFoundation"] = "WITHOUT_FOUNDATION";
})(TriggerFoundationFilter || (TriggerFoundationFilter = {}));
// The settings a newly added configuration starts with, per configurable
// trigger. Doubles as the runtime enumeration of configurable triggers.
export const DEFAULT_TRIGGER_SETTINGS = {
    [SystemProcedure.DebtExpires]: {
        timespanBeforeExpiration: [3, TimespanUnit.Months],
        foundationFilter: TriggerFoundationFilter.Any,
    },
};
export const CONFIGURABLE_TRIGGERS = Object.keys(DEFAULT_TRIGGER_SETTINGS);
export const isConfigurableTrigger = (type) => CONFIGURABLE_TRIGGERS.includes(type);
// The units a timespanBeforeExpiration may use. The settings UI offers
// exactly these; the schema rejects the rest so the API cannot persist units
// the UI can never produce.
export const TRIGGER_TIMESPAN_UNITS = [
    TimespanUnit.Days,
    TimespanUnit.Weeks,
    TimespanUnit.Months,
    TimespanUnit.Years,
];
// Annotated with the settings interface so the schema fails to compile if it
// drifts from TriggerSettingsByProcedure. NOTE: this guard only covers
// DebtExpires — ConfiguredTriggerSchema below applies this settings schema to
// every trigger's entries, so when a second configurable trigger is added its
// settings schema must be dispatched per trigger key here, or zod will
// silently strip the new settings on write.
const DebtExpiresTriggerSettingsSchema = z.object({
    timespanBeforeExpiration: z
        .tuple([
        z.number().int().min(0),
        z
            .enum(TimespanUnit)
            .refine((unit) => TRIGGER_TIMESPAN_UNITS.includes(unit)),
    ])
        .optional(),
    foundationFilter: z.enum(TriggerFoundationFilter).optional(),
});
export const ConfiguredTriggerSchema = z.object({
    procedureIds: z.array(z.string()),
    settings: DebtExpiresTriggerSettingsSchema,
});
// Merges trigger changes into an existing attachment map.
export const applyDefaultProcedureChanges = (defaultProcedures, changes) => {
    const merged = { ...defaultProcedures };
    for (const [type, entry] of Object.entries(changes)) {
        if (entry === undefined) {
            delete merged[type];
        }
        else {
            merged[type] = entry;
        }
    }
    return merged;
};
export const DefaultProceduresSchema = z
    .record(z.string(), z.array(ConfiguredTriggerSchema).optional())
    .transform((defaultProcedures) => applyDefaultProcedureChanges(null, defaultProcedures));
export const procedureIdsFromDefaultProcedureEntry = (entry) => (entry ?? []).flatMap((configuration) => configuration.procedureIds);
export const isZeroTimespan = (timespan) => timespan[0] === 0;
// The canonical "at expiration" timespan. Missing and zero-quantity
// timespans normalize to this single value so dedup keys and window checks
// agree everywhere.
export const ZERO_TIMESPAN = [0, TimespanUnit.Months];
// The effective timespan of a configuration: a missing or zero-quantity
// timespan means "at expiration". Typed over DebtExpires configurations —
// the only trigger whose settings carry a timespan.
export const configuredTriggerTimespan = (configuration) => {
    const timespan = configuration.settings.timespanBeforeExpiration;
    if (timespan === undefined || isZeroTimespan(timespan)) {
        return ZERO_TIMESPAN;
    }
    return timespan;
};
// Stable key identifying a configured timespan, used to deduplicate trigger
// firings per case voucher (stored on updates as data.triggerTimespan). All
// zero-quantity timespans mean "at expiration" regardless of unit, so they
// share a single key.
export const triggerTimespanKey = (timespan) => {
    const canonical = isZeroTimespan(timespan) ? ZERO_TIMESPAN : timespan;
    return `${canonical[0]}-${canonical[1]}`;
};
// Shorthand for a settings-less trigger attachment, used by seeds and
// callers that only care about which procedures run.
export const proceduresEntry = (...procedureIds) => [{ procedureIds, settings: {} }];
//# sourceMappingURL=index.js.map